import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { MDTagComponent } from '@melodic-ui/components';
import { IndicatorType } from '@melodic-ui/types';

//'tutoring', 'chirp room' removed from program type keys
const PROGRAM_TYPE_KEYS = ['excel', 'achieve', 'core', 'middle school core'] as const;
type ProgramTypeKey = (typeof PROGRAM_TYPE_KEYS)[number];
type ProgramTypeStyleKey = ProgramTypeKey | 'default';

type ProgramTypeStyle = {
	className: string;
};

const PROGRAM_TYPE_STYLES: Record<ProgramTypeStyleKey, ProgramTypeStyle> = {
	'excel': { className: 'program-type-tag--excel' },
	'achieve': { className: 'program-type-tag--achieve' },
	'core': { className: 'program-type-tag--core' },
	'middle school core': { className: 'program-type-tag--middle-school-core' },
	// 'tutoring': { className: 'program-type-tag--tutoring' },
	// 'chirp room': { className: 'program-type-tag--chirp-room' },
	'default': { className: 'program-type-tag--default' }
};

function isProgramTypeKey(value: string): value is ProgramTypeKey {
	return PROGRAM_TYPE_KEYS.includes(value as ProgramTypeKey);
}

function normalizeProgramType(value: string | null | undefined): ProgramTypeStyleKey {
	if (!value) {
		return 'default';
	}

	const normalized = value.trim().toLowerCase();

	return isProgramTypeKey(normalized) ? normalized : 'default';
}

@Component({
	selector: 'lb-program-type-tag',
	standalone: true,
	imports: [CommonModule, MDTagComponent],
	template: `
		<md-tag type="default" [variant]="variant()" [ngClass]="tagClasses()" [attr.data-program-type]="normalizedProgramType()">
			{{ displayLabel() }}
		</md-tag>
	`,
	styleUrl: './program-type-tag.component.scss'
})
export class ProgramTypeTagComponent {
	programType = input<string | null | undefined>();
	program = input<string | null | undefined>();
	variant = input<'default' | 'modern'>('default');
	showFullName = input<boolean>(false);

	private readonly _fallbackLabel = 'Program';

	private readonly _normalizedProgramType = computed(() => normalizeProgramType(this.programType()));

	normalizedProgramType = this._normalizedProgramType;

	displayLabel = computed(() => {
		if (this.showFullName()) {
			return this.program() || this.programType() || this._fallbackLabel;
		} else {
			return this.programType() || this.program() || this._fallbackLabel;
		}
	});

	tagClasses = computed(() => {
		const normalized = this._normalizedProgramType();
		const className = PROGRAM_TYPE_STYLES[normalized].className;

		return ['program-type-tag', className].filter(Boolean);
	});
}
